function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9.002,1.396 L3.461,7.002 L-0.002,3.498 L1.383,2.096 L3.461,4.199 L7.617,-0.006 L9.002,1.396 Z"
});

var SvgCheck9X7 = function SvgCheck9X7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "7px"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/check-9x7.671481aa.svg";
export { SvgCheck9X7 as ReactComponent };